import React from "react";
import { Box, Flex, Text, Icon, Divider, Stack } from "@chakra-ui/react";
import { Banknote, Landmark, Wallet } from "lucide-react";
import ReusableDrawer from "components/Drawers/ReusableDrawer";

const ViewBankDetailsDrawer = ({ isOpen, onClose, bank }) => {
  if (!bank) return null;

  return (
    <ReusableDrawer
      isOpen={isOpen}
      onClose={onClose}
      headerContent={<Text fontSize="2xl" fontWeight="bold">Bank Details</Text>}
      bodyContent={
        <Flex direction="column" p={8} width="100%">
          <Box>
            <Text fontSize="2xl" fontWeight="bold">{bank.bank_name}</Text>
            <Text fontSize="sm" color="gray.500" mt={1}>Branch: {bank.branch_name}</Text>
          </Box>

          <Divider my={6} />

          <Flex direction="column" p={4}>
            <Box mb={6}>
              <Stack spacing={4}>
                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Landmark} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Bank Name: {bank.bank_name}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Banknote} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Branch Name: {bank.branch_name}
                  </Text>
                </Flex>

                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Wallet} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Account Number: {bank.account_number}
                  </Text>
                </Flex>

                {/* Added SWIFT Code */}
                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Banknote} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    SWIFT Code: {bank.swift_code || "N/A"}
                  </Text>
                </Flex>

                {/* Added Branch Code */}
                <Flex border="1px" borderColor="gray.300" borderRadius="md" p={3}>
                  <Icon as={Banknote} mr={2} color="gray.400" />
                  <Text fontWeight="500" color="gray.600" fontSize="sm">
                    Branch Code: {bank.branch_code || "N/A"}
                  </Text>
                </Flex>
              </Stack>
            </Box>
          </Flex>
        </Flex>
      }
    />
  );
};

export default ViewBankDetailsDrawer;
